import { createContext, useContext, useEffect, useRef, useState } from "react"
import { useLocation } from "react-router"

const PreviousLocationContext = createContext(null)

export function PreviousLocationProvider({ children }) {
	const location = useLocation()
	const prevLocationRef = useRef("/")
	const [prevLocation, setPrevLocation] = useState("/")

	useEffect(() => {
		setPrevLocation(prevLocationRef.current)
		prevLocationRef.current = location
	}, [location])

	return (
		<PreviousLocationContext.Provider value={prevLocation}>
		{children}
		</PreviousLocationContext.Provider>
	)
}

export const usePreviousLocation = () => useContext(PreviousLocationContext)
